package br.com.duoma.duomaproducao.model

import androidx.constraintlayout.core.state.ConstraintSetParser.Companion.override
import androidx.navigation.NavType
import kotlinx.serialization.Serializable
import kotlinx.serialization.Serializer

@Serializable
enum class WorkCenter(val order : Int, val _name : String, val cascades : Boolean = true) {
    CORTE(0, "Corte", true),
    COSTURA(5, "Costura"),
    LAMINACAO(1, "Laminação"),
    MARCENARIA(2, "Marcenaria"),
    MONTAGEM(3, "Montagem"),
    PREPARACAO_EST(4, "Preparação", true),
    ESPUMACAO(6, "Espumação"),
    TAPECARIA(7, "Tapeçaria", true);

    companion object {
        fun fromName(name: String): WorkCenter = entries.find {
                it.name.equals(name.replace(" ", "_"), ignoreCase = true)
            } ?: throw IllegalArgumentException("Unknown workcenter: '$name")
    }
    fun toSevenName() = name.replace("_", " ")
    override fun toString(): String {
        return _name
    }
}